import { render, staticRenderFns } from "./associatedBusinessForm.vue?vue&type=template&id=45101cdd&scoped=true&"
import script from "./associatedBusinessForm.vue?vue&type=script&lang=js&"
export * from "./associatedBusinessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45101cdd",
  null
  
)

export default component.exports